if (!customElements.get('vbb-product-card-variant-selector')) {
  customElements.define('vbb-product-card-variant-selector', class ProductCardVariantSelector extends HTMLElement {
    constructor() {
      super();

      this.rootUrl = this.dataset.rootUrl;
      this.productForm = this.closest('vbb-product-form-reactive');
      this.productFormId = this.productForm?.id ?? null;
      this.variantButtons = this.querySelectorAll('button:not(.carousel-button)');
      this.options = this.querySelectorAll(':scope ul ul[data-option]');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.variantButtons.forEach(variantButton => {
        variantButton.addEventListener('click', () => {
          this.updateActiveVariant(variantButton);
          this.updateLabel(this.activeVariantId);
          this.updateImage(this.activeVariantId);
        })

        variantButton.addEventListener('mouseenter', () => {
          const listItem = variantButton.closest('li');
          const newVariantId = listItem.dataset.variantId;
          this.updateLabel(newVariantId);
          this.updateImage(newVariantId);
        });

        variantButton.addEventListener('mouseleave', () => {
          this.updateLabel(this.activeVariantId);
          this.updateImage(this.activeVariantId);
        });
      });
    }

    updateLabel(variantId) {
      const parsedVariantId = parseInt(variantId, 10);
      this.activeVariantLabel = this.querySelector('label');
      if (!parsedVariantId || !this.activeVariantLabel) {
        return;
      }
      const options = this.variantDetails.find(({ variantId }) => variantId === parsedVariantId).optionsOriginal;
      this.activeVariantLabel.innerText = options.join(' / ');
    }

    updateImage(variantId) {
      const parsedVariantId = parseInt(variantId, 10);

      this.activeVariantImage = this.closest('.vbb-product-card').querySelector('figure img');

      if (!parsedVariantId || !this.activeVariantImage) {
        return;
      }

      const newImageSelector = `[data-template="product-card-image"][data-variant-id="${parsedVariantId}"]`;
      const newImage = this.productForm.querySelector(newImageSelector).content.cloneNode(true);

      this.activeVariantImage.replaceWith(newImage);
    }

    updateActiveVariant(variantButton) {
      const listItem = variantButton.closest('li');
      const optionName = listItem.dataset.optionName;
      const optionValue = listItem.dataset.optionValue;

      // Get all currently active options
      const activeOptions = Array.from(this.options).map(optionList => {
        const activeLi = optionList.querySelector('[data-active="true"]');
        return activeLi.dataset.optionValue;
      });

      // Find index of the option being changed
      const optionIndex = Array.from(this.options).findIndex(
        list => list.dataset.option === optionName
      );

      // Update activeOptions with the newly selected value
      activeOptions[optionIndex] = optionValue;

      // Find the variant that matches all active options
      const newVariant = this.variantDetails.find(variant => {
        return JSON.stringify(variant.options) === JSON.stringify(activeOptions);
      });

      // Update active variant ID
      this.activeVariantId = newVariant?.variantId;

      // Update active states
      const optionList = listItem.closest('ul');
      optionList.querySelectorAll('li').forEach(li => {
        li.dataset.active = (li === listItem);
      });

      // Update all variant IDs and URLs
      this.options.forEach(optionList => {
        optionList.querySelectorAll('li').forEach(li => {
          const thisOptionName = li.dataset.optionName;
          const thisOptionValue = li.dataset.optionValue;

          // Create temporary options array for this combination
          const tempOptions = [...activeOptions];
          const thisOptionIndex = Array.from(this.options).findIndex(
            list => list.dataset.option === thisOptionName
          );
          tempOptions[thisOptionIndex] = thisOptionValue;

          // Find matching variant
          const matchingVariant = this.variantDetails.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(tempOptions)
          );

          // Update variant ID and URL
          if (matchingVariant) {
            li.dataset.variantId = matchingVariant.variantId;
            li.dataset.outOfStock = matchingVariant.inStock ? 'false' : 'true';
          }
        });
      });

      // Update the hidden input
      const hiddenInput = this.querySelector('input');
      hiddenInput.value = this.activeVariantId;

      // Dispatch change event
      document.dispatchEvent(new CustomEvent('variant:selected', {
        detail: {
          productFormId: this.productFormId,
          variantId: this.activeVariantId,
        },
        bubbles: true,
      }));
    }

    get variantDetails() {
      const variantData = this.productForm.querySelector(`#variant-details-${this.productFormId}`)?.textContent;

      if (!variantData) {
        console.warn('No variant data found');
        return [];
      }

      return JSON.parse(variantData);
    }

    get activeVariantId() {
      return parseInt(this.dataset.activeVariantId, 10);
    }

    set activeVariantId(newActiveVariantId) {
      this.dataset.activeVariantId = parseInt(newActiveVariantId, 10);
    }
  });
}
